<template>
  <div class="taf-field">
    <label>Adjuntos <span class="taf-optional">opcional · máx. 5 archivos, 10MB c/u</span></label>
    <label class="taf-dropzone" :class="{ 'taf-dropzone--has': value.length }">
      <input type="file" multiple accept=".jpg,.jpeg,.png,.pdf,.doc,.docx,.xls,.xlsx" @change="chooseFiles" hidden />
      <div v-if="!value.length" class="taf-dropzone-empty">
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
          <path d="M12 5v14M5 12h14" stroke="#01662E" stroke-width="2" stroke-linecap="round"/>
        </svg>
        <span>Agregar archivos</span>
      </div>
      <div v-else class="taf-dropzone-list">
        <span v-for="(file, index) in value" :key="index" class="taf-chip">{{ file.name }}</span>
        <small class="taf-helper">Click para cambiar</small>
      </div>
    </label>
    <div v-if="rejectedMessage" class="taf-alert">{{ rejectedMessage }}</div>
  </div>
</template>

<script>
const MAX_ATTACHMENTS = 5;
const MAX_ATTACHMENT_SIZE_MB = 10;
const BYTES_PER_MB = 1024 * 1024;
const MAX_ATTACHMENT_SIZE_BYTES = MAX_ATTACHMENT_SIZE_MB * BYTES_PER_MB;

export default {
  name: 'TicketAttachmentsField',
  props: {
    value: { type: Array, default: () => [] },
  },
  data() {
    return { rejectedMessage: '' };
  },
  methods: {
    chooseFiles(event) {
      const files = Array.from(event.target.files).slice(0, MAX_ATTACHMENTS);
      const tooBig = files.filter((file) => file.size > MAX_ATTACHMENT_SIZE_BYTES);
      this.rejectedMessage = tooBig.length
        ? `No se adjuntó: ${tooBig.map((file) => file.name).join(', ')}. Cada archivo puede pesar máximo ${MAX_ATTACHMENT_SIZE_MB} MB.`
        : '';
      this.$emit('input', files.filter((file) => file.size <= MAX_ATTACHMENT_SIZE_BYTES));
    },
  },
};
</script>

<style scoped>
.taf-field { margin-bottom: 16px; }
.taf-field > label:first-child {
  font-weight: 600;
  font-size: 12.5px;
  color: #374151;
  margin-bottom: 6px;
  display: block;
  letter-spacing: 0.1px;
}
.taf-optional {
  font-weight: 400;
  color: #9ca3af;
  font-size: 12px;
  margin-left: 6px;
}
.taf-dropzone {
  display: block;
  border: 2px dashed #d1d5db;
  border-radius: 10px;
  padding: 16px;
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease;
  background: #fafbfa;
}
.taf-dropzone:hover {
  border-color: #01662E;
  background: #f4faf6;
}
.taf-dropzone--has {
  border-style: solid;
  border-color: #01662E;
  background: #f4faf6;
}
.taf-dropzone-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #01662E;
  font-size: 13px;
  font-weight: 500;
}
.taf-dropzone-list {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
}
.taf-chip {
  background: #fff;
  border: 1px solid #d3ecde;
  color: #01662E;
  font-size: 12px;
  padding: 4px 10px;
  border-radius: 14px;
  font-weight: 500;
}
.taf-helper {
  display: block;
  text-align: right;
  font-size: 11.5px;
  color: #9ca3af;
  margin-top: 4px;
}
.taf-alert {
  border-radius: 10px;
  padding: 10px 14px;
  font-size: 13px;
  margin-top: 12px;
  background: #fef2f2;
  color: #b91c1c;
  border-left: 3px solid #b91c1c;
}
</style>
